import {SAVE_INFO_USER, SAVE_LOGIN, SAVE_LIST_USER_LOGIN_PERMISSION, SHOW_POPUP_LOGIN } from '@/constants/ActionTypes';

  const initialState = {
    token: null,
    infoUser: null,
    listUserLoginPermission: [],
    showLogin : 0
};
const homeReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_INFO_USER:
            return {
                ...state,
                infoUser: action.payload
            };
        case SHOW_POPUP_LOGIN:
            return {
                ...state,
                showLogin: action.payload
            };
        case SAVE_LOGIN:
            return {
                ...state,
                token: action.payload
            };
        case SAVE_LIST_USER_LOGIN_PERMISSION:
            return {
                ...state,
                listUserLoginPermission: action.payload
            };
        default:
            return { ...state };
    }
};
export default homeReducer;